import React from 'react';
import { Apple, Droplets, House, Sparkles, SprayCan, UtensilsCrossed } from 'lucide-react';

const CATEGORY_ICON_THEME = {
  foods: {
    primaryIcon: Apple,
    accentIcon: UtensilsCrossed,
    gradient: 'linear-gradient(150deg, rgba(241, 223, 181, 0.96) 0%, rgba(214, 183, 124, 0.92) 100%)',
    borderColor: 'rgba(247, 234, 207, 0.95)',
    foreground: '#133027',
    accentBackground: 'rgba(250, 242, 226, 0.96)',
  },
  household: {
    primaryIcon: House,
    accentIcon: SprayCan,
    gradient: 'linear-gradient(150deg, rgba(199, 224, 214, 0.96) 0%, rgba(147, 185, 167, 0.92) 100%)',
    borderColor: 'rgba(225, 239, 233, 0.95)',
    foreground: '#0f3d2c',
    accentBackground: 'rgba(237, 247, 243, 0.96)',
  },
  bodycare: {
    primaryIcon: Droplets,
    accentIcon: Sparkles,
    gradient: 'linear-gradient(150deg, rgba(209, 232, 250, 0.96) 0%, rgba(122, 178, 221, 0.92) 100%)',
    borderColor: 'rgba(225, 241, 252, 0.95)',
    foreground: '#164B75',
    accentBackground: 'rgba(235, 246, 255, 0.96)',
  },
};

export function CategoryIcon({ categoryId, compact = false, className = '' }) {
  const theme = CATEGORY_ICON_THEME[categoryId] || CATEGORY_ICON_THEME.foods;
  const PrimaryIcon = theme.primaryIcon;
  const AccentIcon = theme.accentIcon;

  return (
    <span className={`relative inline-flex shrink-0 ${className}`} aria-hidden="true">
      <span
        className={`relative inline-flex items-center justify-center overflow-hidden border shadow-[0_10px_26px_rgba(0,0,0,0.14)] ${
          compact ? 'h-10 w-10 rounded-2xl' : 'h-14 w-14 rounded-[1.2rem]'
        }`}
        style={{
          background: theme.gradient,
          borderColor: theme.borderColor,
        }}
      >
        <span className="absolute inset-[4px] rounded-[inherit] border border-white/45" />
        <PrimaryIcon
          className={compact ? 'h-5 w-5' : 'h-7 w-7'}
          style={{ color: theme.foreground }}
          strokeWidth={2.1}
        />
      </span>

      <span
        className={`absolute inline-flex items-center justify-center rounded-full border border-white/70 shadow-[0_8px_18px_rgba(0,0,0,0.22)] ${
          compact ? '-bottom-1 -right-1 h-5 w-5' : '-bottom-1.5 -right-1.5 h-7 w-7'
        }`}
        style={{ backgroundColor: theme.accentBackground }}
      >
        <AccentIcon
          className={compact ? 'h-3 w-3' : 'h-4 w-4'}
          style={{ color: theme.foreground }}
          strokeWidth={2.1}
        />
      </span>
    </span>
  );
}
